import React from 'react';
import { SpinnerCircular } from 'spinners-react';

const LoadingSpinner: React.FunctionComponent = () => {
    return <SpinnerCircular speed={150} secondaryColor="rgba(6, 182, 212, 0.15)" color="#06B6D4" size={48} thickness={140} />;
};

export default LoadingSpinner;
